import { useEffect } from 'react';

import { useAuthorizedUser } from 'Services/User/useAuthorizedUser';
import { useSubscription } from 'Shared/hooks/useSubscription';
import { createStore } from 'Utils/store';

const followingsStore = createStore<Record<string, boolean>>({});

const addFollowings = (ids: ReadonlyArray<string> | string) => {
  const next = {};

  if (Array.isArray(ids)) {
    ids.forEach((id) => {
      // @ts-expect-error ImplicitAny
      return (next[id] = true);
    });
  } else {
    // @ts-expect-error ImplicitAny
    next[ids as string] = true;
  }

  followingsStore.setCurrentValue((prev) => {
    return {
      ...prev,
      ...next,
    };
  });
};

const removeFollowings = (ids: ReadonlyArray<string> | string) => {
  const next = {};

  if (Array.isArray(ids)) {
    ids.forEach((id) => {
      // @ts-expect-error ImplicitAny
      return (next[id] = false);
    });
  } else {
    // @ts-expect-error ImplicitAny
    next[ids as string] = false;
  }

  followingsStore.setCurrentValue((prev) => {
    return {
      ...prev,
      ...next,
    };
  });
};

export const useFollowings = () => {
  const { isAuthorized } = useAuthorizedUser();

  const followings = useSubscription(followingsStore);

  useEffect(() => {
    if (isAuthorized) {
      return;
    }

    followingsStore.setCurrentValue({});
  }, [isAuthorized]);

  return {
    followings,
    addFollowings,
    removeFollowings,
  };
};
